// removed by extract-text-webpack-plugin
module.exports = {"title":"index__title___2spq2","labelCol":"index__labelCol___3eAVH","topSixBackground":"index__topSixBackground___3nvht","row-header":"index__row-header___2vlXW","row":"index__row___1Ov4P"};


//////////////////
// WEBPACK FOOTER
// ./src/views/MergeLeads/components/index.less
// module id = 1461
// module chunks = 3